export default __webpack_public_path__ + "static/media/switching.0e550ff9.svg";